import { getEnvConfig } from './get-env-config';

export default getEnvConfig();
